import { render, staticRenderFns } from "./Results-add.vue?vue&type=template&id=3af148ae&scoped=true&"
import script from "./Results-add.vue?vue&type=script&lang=js&"
export * from "./Results-add.vue?vue&type=script&lang=js&"
import style0 from "./Results-add.vue?vue&type=style&index=0&id=3af148ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af148ae",
  null
  
)

export default component.exports